import { SET_PAGE } from "../config/constants";

const initialState = {
  page: 1,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_PAGE:
      return { ...state, page: action.payload };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/reducer/page.reducer.js